import React from 'react';
import Services from './../services/services';
import Product from './Product';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const ProductRelated = (props: any) => {

  const [products, setProducts] = useState([]);

  const services = new Services();

  useEffect(()=>{

    services.getProductsType('public').then( (value: any) => {
      setProducts(value)
    });

    console.log("props_id",props.id);

  }, [])


  const productList: any[] = [];

  products.forEach((data: any) => {

    if( !(data.id == props.id) ){
      if( data.attachment[0] !== undefined ){
        productList.push(<Product id={data.id} name={data.name} description={data.short} price={data.price} image={data.attachment[0].path}/>)
      }else{
        productList.push(<Product id={data.id} name={data.name} description={data.short} price={data.price} image={null}/>)
      }
    }

  })

  const shuffled = productList.sort(() => 0.5 - Math.random());

  return (
    <div className="mt-5 pt-4">
      <div className="container my-5">
      <h1>Související produkty</h1>
        <div className="row">
          {shuffled[0]}
          {shuffled[1]}
          <div className="col-12 col-lg-4 mb-4 my-2">

            <div className="card custom-radius custom-shadow border-0 blog-card my-2 h-100">

              <div className="img-container-16-9 img-container">
                <img src="http://balony.techcrowd.space/wp-content/uploads/2022/09/privat.jpg" className="card-img-top custom-radius-top" alt="..."/>
              </div>

              <div className="card-body d-flex flex-column justify-content-between">

              <div>
              <p className="fs-2">
                Privátní let
              </p>

              <div className="d-flex">
              <span className="me-4 text-secondary">
                <i className="fa-regular fa-user text-primary"></i> Pouze pro vás
              </span>
              <span className="me-2  text-secondary">
                <i className="fa-regular fa-map text-primary"></i> Místo startu je na vás
              </span>
              </div>

              <div className="mt-3 text-secondary">
                Je pouze na vás, jaké místo startu si vyberete a s kým poletíte.
              </div>

              </div>

              <div className="d-flex flex-row justify-content-between align-items-center">
                <div className="text-secondary fs-4">
                  od 16990 Kč
                </div>
                <div>

                  <a className='btn btn-primary rounded-pill px-4' href='/app/private'>Prozkoumat</a>

                </div>
              </div>

              </div>

            </div>


          </div>

        </div>
      </div>
    </div>
  );

}

export default ProductRelated;
